import script from "./PostCode.vue?vue&type=script&setup=true&lang=js"
export * from "./PostCode.vue?vue&type=script&setup=true&lang=js"

import "./PostCode.vue?vue&type=style&index=0&id=404f74ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404f74ae"]])

export default __exports__